module.exports = __webpack_public_path__ + "img/buissonniere.2c4a2a1d.jpg";